<template>
  <b-container fluid>
    <div class="iq-card p-3 row">
      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
        <h4>
          <i class="fa fa-solid fa-graduation-cap" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>
          {{cvCardTitle}}
        </h4>
      </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
        <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="goToTestPrepPdtPage" v-if="moreBatchesToBuy && userData?.user_role == 'USERROLE11114'">{{cvbtnGidePrep}}</b-button>
        <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="goToGIDEPrepDashboard" v-if="userData?.user_role == 'USERROLE11111' || userData?.user_role == 'USERROLE11118'">
          Testseries Admin Dashboard
        </b-button>
        <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="goToQuizDashboard" v-if="userData?.user_role == 'USERROLE11111' || userData?.user_role == 'USERROLE11118'">
          Quiz Dashboard
        </b-button>
      </div>
    </div>
    <b-row class="container_maxheight">
      <b-col v-for="(mcObj,index) in moduleCountObj" :key="index" class="mt-3 col-12 col-sm-6 col-md-4 col-lg-3">
        <iq-card class="side_border" style="cursor: pointer;">
          <div class="text-left px-2 py-3" @click="goToModuleView(mcObj)">
            <h5 class="title pl-2 twoLineOnly pr-3 pointer m-0" :title="mcObj.subject">
              {{ mcObj.subject }}
              <!-- <span class="pull-right" title="Total Modules/Tests Available">{{ mcObj.total_modules }}</span><br> -->
            </h5>
            <h6 class="ml-2">{{ mcObj.desc }}</h6>
            <div class="mt-3" style="text-align:right;">
              <b-button variant="iq-bg-primary mr-1 mb-0" size="sm">
                <i class="fa fa-solid fa-graduation-cap font-size-18"></i>
              </b-button>
            </div>
          </div>
        </iq-card>
      </b-col>
    </b-row>

    <!-- Student Counsellor Form V1 -->
    <b-modal
      v-model="showCounsellingQuizModalv1"
      scrollable
      :title="cvSpcmSpcmCounsellorFormTitle"
      size="xxl"
      hide-footer
    >
      <PAQ :propQuestionObj="questionObj" :propParentModuleObj="tPrepObj" :propContractId="contractId" @emitClosePreCounsellingQuizModal="closeCounsellingQuizModal" @emitContractTnCAccept="contractTnCAccept"/>
    </b-modal><!--Student Counsellor Form V1 -->

    <!-- Gide Contract -->
    <b-modal
      v-model="showModalGideContracts"
      scrollable
      size="xxl"
      title="GIDE TestPrep Contract"
      hide-footer
    >
      <GideContract :propOpenedInModal="true" :propGideContractObj="gideContractObj" :propContractId="contractId" @emitcloseGIDECounselingContractModal="closeGIDECounselingContractModal" @emitContractTnCAccept="contractTnCAccept"/>
    </b-modal><!-- Gide Contract -->
  </b-container>
</template>
<script>
import { TPrepSubjectModules } from "../../../FackApi/api/TPrepSubjectModule"
import { socialvue } from "../../../config/pluginInit"
import TestSeriesConfig from "../../../FackApi/json/TestSeries.json"
import TestSeriesProdConfig from "../../../FackApi/json/TestSeriesProd.json"
import { TprepSessions } from "../../../FackApi/api/TprepSession"
import GideContract from "../SPCM/GideContract.vue"
import PAQ from "../SPCM/PAQ.vue"

export default {
  name: "TSeriesProductList",
  components: {
    GideContract,
    PAQ
  },
  data () {
    return {
      TestSeriesConfigJson: TestSeriesProdConfig,
      apiName: "user_interest_list",
      showInterestModal: false,
      moduleCountObj: TestSeriesProdConfig.SUPPORTED_EXAMS,
      cvSearchText: "Type to search",
      cvCardTitle: "Testseries Products",
      filter: null,
      filterOn: [],
      userSubject: null,
      cvbtnGidePrep: "Add",
      moreBatchesToBuy: false,
      userSubjectInterest: null,
      gide_user_id: null,
      selectedSubject: "",
      searchKeyword: "",
      testprepPayments: null,
      examBatchCount: null,
      cvSpcmSpcmCounsellorFormTitle: "Student Onboarding Form",
      showCounsellingQuizModalv1: false,
      showModalGideContracts: false,
      gideContractObj: null,
      contractId: "BLOGGIDEPREPContractGIDEPREPId0002",
      questionObj: null,
      tPrepObj: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    if (process.env.VUE_APP_ENV != "prod") {
      this.TestSeriesConfigJson = TestSeriesConfig
      this.moduleCountObj = TestSeriesConfig.SUPPORTED_EXAMS
    }

    this.gide_user_id = this.$route.query.gide_user_id ? this.$route.query.gide_user_id : this.userData.user_id
    await this.processPendingpayment()
  },
  async mounted () {
    socialvue.index()
    this.getModules()

    this.launchPAQContract()
  },
  methods: {
    /**
     * processPendingpayment
     */
    async processPendingpayment () {
      try {
        const paymentProcessResp = await TprepSessions.tprep_sessionCheckPayment(this, { gide_user_id: this.gide_user_id })
        // console.log("paymentProcessResp ", paymentProcessResp)
        if (paymentProcessResp.resp_status) {
          this.testprepPayments = paymentProcessResp.resp_data
          this.examBatchCount = paymentProcessResp.resp_data_1
        }
      }
      catch (err) {
        console.error("Exceptopn in processPendingpayment() and err: ", err.message)
      }
    },
    /**
     * goToTestPrepPdtPage
     */
    goToTestPrepPdtPage () {
      this.$router.push(`/testseries_exam_details/${this.TestSeriesConfigJson.TESTSERIES_SAT_PRODUCT_PAGE_APP_ID}`)
    },
    /**
     * getModules
     */
    async getModules () {
      try {
        let newModCountObj = [...this.TestSeriesConfigJson.SUPPORTED_EXAMS]

        const tprepModuleCountObj = {}
        if (this.$route.query.gide_user_id && (this.userData.user_role === "USERROLE11111" || this.userData.user_role === "USERROLE11118")) {
          tprepModuleCountObj.gide_user_id = this.$route.query.gide_user_id
        }

        tprepModuleCountObj.filter = this.userSubjectInterest

        const moduleCountResp = await TPrepSubjectModules.tprepSubjectModuleCount(this, tprepModuleCountObj)
        if (moduleCountResp.resp_status) {
          for (let moduleCount of moduleCountResp.resp_data.data) {
            const index = newModCountObj.findIndex(e => e.subject === moduleCount.subject)
            if (index !== -1) {
              newModCountObj[index].total_modules = moduleCount.total_modules
            }
          }
        }
        else {
          this.moduleCountObj = []
          this.toastMsg = moduleCountResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }

        this.moduleCountObj = [...newModCountObj] // display list
      }
      catch (err) {
        console.error("Exception in getModules():", err.message)
      }
    },
    /**
     * goTo Module View
     */
    goToModuleView (modObj) {
      if (modObj.url) {
        // Used for those assessments where we have to redirect to another link
        this.$router.push(modObj.url)
      }

      // check if the user has a session for the clicked subject
      let interestId = `TESTSERIES_${modObj.subject.replaceAll("-", "_")}_MOCK`
      const isTprepSessionExists = this.examBatchCount.find(e => e.interest_id == interestId)

      console.error("clicked card interest_id: ", interestId, "Interest found in tprep sessions: ", isTprepSessionExists?.interest_id)
      if (!isTprepSessionExists) {
        // Redirect to exam details of the respective exam, to allow the user to make payment
        this.$router.push(`/testseries_exam_details/${modObj.pdt_id}`)
      }
      else {
        if (this.$route.query.gide_user_id) {
          this.$router.push(`/subject_modules/${modObj.interest_id}?gide_user_id=${this.$route.query.gide_user_id}`)
        }
        else {
          this.$router.push(`/subject_modules/${modObj.interest_id}`)
        }
      }
    },
    /**
     * goTo GIDEPrep Dashboard
     */
    goToGIDEPrepDashboard () {
      this.$router.push("/testseries_admin_dashboard")
    },
    /**
     * goTo QUIZ/APP Dashboard
     */
    goToQuizDashboard () {
      this.$router.push("/quiz_list")
    },
    /**
     * launch PAQ Contract
     */
    async launchPAQContract () {
      this.tPrepObj = await this.tprepSubjectModuleDistincte("tprep_tnc, tprep_id")
      if (!this.tPrepObj) {
        // if tPrepObj is NULL or {} means user has done B2C Payment with pay_tid & aff_code starting with "pay_"
        // In such a scenario dont launch the PAQ or GIDEContract
        return
      }
      this.tPrepObj.parent_module_name = "TPREP"

      // Check Contract Form is submitted or not
      if (!(this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118") && !this.tPrepObj?.tprep_tnc) {
        let golive = 1
        if (golive == 1) {
          // Open the PAQ in a Modal Box if the Contract is not accepted by Student/Parent
          this.questionObj = {
            app_id: "PRE_COUNSELING_APP_ID",
            user_id: this.gide_user_id,
            tnc_flag: this.tPrepObj.spcm_tnc
          }

          this.showCounsellingQuizModalv1 = true
        }
        else {
          // Open the Contract in a Modal Box if the Contract is not accepted by Student/Parent
          this.viewContract(this.tPrepObj)
        }
      }
    },
    /*
     * tprepSubjectModuleDistincte
     */
    async tprepSubjectModuleDistincte (filterName = null) {
      try {
        let subModuleFilterListResp = await TPrepSubjectModules.tprepSubjectModuleDistincte(this, filterName, this.gide_user_id)
        if (subModuleFilterListResp?.resp_status) {
          this.tPrepObj = subModuleFilterListResp.resp_data[0]
        }
      }
      catch (err) {
        console.error("Exception occurred at tprep_subject_module_distincte() and Exception:", err.message)
      }

      return this.tPrepObj
    },
    /**
     * close PreCounselling Quiz Modal
     */
    closeCounsellingQuizModal () {
      this.showCounsellingQuizModalv1 = false
    },
    /**
     * view Gide contracts
     */
    viewContract (tPrepObj) {
      this.gideContractObj = tPrepObj

      this.gideContractObj.spcm_category = "SPCM-GIDEPREP"
      this.gideContractObj.spcm_contract = tPrepObj.tprep_contract
      this.gideContractObj.tprep_tnc = tPrepObj.tprep_tnc
      this.gideContractObj.blog_id = this.contractId
      this.showModalGideContracts = true
    },
    /**
     * close GIDECounselingContractModal
     */
    async closeGIDECounselingContractModal () {
      this.tPrepObj = await this.tprepSubjectModuleDistincte("tprep_tnc, tprep_id")
      this.tPrepObj.parent_module_name = "TPREP"
      this.getModules()
      this.showModalGideContracts = false
      this.showCounsellingQuizModalv1 = false
    },
    /**
     * GIDEPrep TnC Accept
     */
    async contractTnCAccept () {
      let payload = {
        tprep_id: this.tPrepObj.tprep_id,
        tprep_tnc: 1
      }

      TprepSessions.tprep_contract_update(this, payload)

      this.closeGIDECounselingContractModal()
    }
  }
}
</script>
<style scoped>
.zero-screen {
  height: calc(100vh - 130.19px);
}
</style>
